import { Tag } from '@/components'

import UtilityProgramHelpers from '@/utils/utility-program-helpers/utilityProgramHelpers'
import { useDeviceVerificationStatus } from '@/hooks/useDeviceVerificationStatus/useDeviceVerificationStatus'
import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'

type VerificationStatusTagProps = {
  programId: number
  deviceId: number | string
  deviceType: DeviceType
}

export default function VerificationStatusTag(
  props: VerificationStatusTagProps,
) {
  const { deviceStatus } = useDeviceVerificationStatus(props)

  const formattedStatusInfo =
    UtilityProgramHelpers.verificationStatusToDisplay(deviceStatus)

  if (!formattedStatusInfo.visible) {
    return null
  }

  return (
    <Tag color={formattedStatusInfo?.bgColor}>
      <div className={`font-bold text-[12px] ${formattedStatusInfo?.color}`}>
        {`${formattedStatusInfo?.text}`}
      </div>
    </Tag>
  )
}
